<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.8333 9.99999H4.16663M4.16663 9.99999L9.99996 15.8333M4.16663 9.99999L9.99996 4.16666" stroke="#0D0D0D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
